// Market-cap weights (billions) for treemap sizing — static, live % change comes from Finnhub
export const initialTree = {
  name: 'US Market',
  children: [
    {
      name: 'Electronic technology',
      children: [
        {
          name: 'Aerospace & Defense',
          children: [
            { name: 'SPCX', value: 2100, change: 0 },
            { name: 'GE', value: 314, change: 0 },
            { name: 'RTX', value: 275, change: 0 },
            { name: 'BA', value: 165, change: 0 },
            { name: 'LMT', value: 149, change: 0 },
            { name: 'LHX', value: 42, change: 0 },
            { name: 'NOC', value: 104, change: 0 },
            { name: 'GD', value: 95, change: 0 },
            { name: 'HWM', value: 95, change: 0 },
            { name: 'TDG', value: 69, change: 0 },
            { name: 'AXON', value: 40, change: 0 },
            { name: 'RKLB', value: 39, change: 0 },
            { name: 'KTOS', value: 16, change: 0 },
            { name: 'HII', value: 16, change: 0 },
            { name: 'DRS', value: 12, change: 0 },
            { name: 'AVAV', value: 10, change: 0 },
            { name: 'PL', value: 8, change: 0 },
            { name: 'FLY', value: 4, change: 0 },
            { name: 'LUNR', value: 4, change: 0 },
            { name: 'RCAT', value: 2, change: 0 },
            { name: 'RDW', value: 2, change: 0 },
          ],
        },
        { name: 'Automobile Manufacturers', children: [{ name: 'TSLA', value: 1470, change: 0 }] },
        { name: 'Communications Equipment', children: [{ name: 'ANET', value: 168, change: 0 }] },
        { name: 'Electrical Components & Equipment', children: [{ name: 'VRT', value: 99, change: 0 }] },
        { name: 'Industrial Conglomerates', children: [{ name: 'HON', value: 149, change: 0 }] },
        {
          name: 'Semiconductor Materials & Equipment',
          children: [
            { name: 'ASML', value: 528, change: 0 },
            { name: 'AMAT', value: 160, change: 0 },
            { name: 'KLAC', value: 186, change: 0 },
          ],
        },
        {
          name: 'Semiconductors',
          children: [
            { name: 'NVDA', value: 4380, change: 0 },
            { name: 'TSM', value: 1755, change: 0 },
            { name: 'AVGO', value: 1530, change: 0 },
            { name: 'MU', value: 480, change: 0 },
            { name: 'AMD', value: 315, change: 0 },
            { name: 'INTC', value: 229, change: 0 },
            { name: 'TXN', value: 174, change: 0 },
            { name: 'ADI', value: 149, change: 0 },
            { name: 'QCOM', value: 139, change: 0 },
          ],
        },
        {
          name: 'Technology Hardware, Storage & Peripherals',
          children: [
            { name: 'AAPL', value: 3670, change: 0 },
            { name: 'DELL', value: 100, change: 0 },
            { name: 'SNDK', value: 98, change: 0 },
            { name: 'WDC', value: 92, change: 0 },
            { name: 'STX', value: 84, change: 0 },
          ],
        },
      ],
    },
    {
      name: 'Technology services',
      children: [
        {
          name: 'Application Software',
          children: [
            { name: 'ORCL', value: 446, change: 0 },
            { name: 'PLTR', value: 361, change: 0 },
            { name: 'CRM', value: 178, change: 0 },
            { name: 'ADBE', value: 102, change: 0 },
            { name: 'PATH', value: 6, change: 0 },
            { name: 'SOUN', value: 3, change: 0 },
          ],
        },
        { name: 'Broadline Retail', children: [{ name: 'AMZN', value: 2230, change: 0 }] },
        { name: 'Diversified Support Services', children: [{ name: 'LDOS', value: 22, change: 0 }] },
        {
          name: 'Interactive Media & Services',
          children: [
            { name: 'GOOG', value: 3650, change: 0 },
            { name: 'META', value: 1550, change: 0 },
          ],
        },
        { name: 'IT Consulting & Other Services', children: [{ name: 'IBM', value: 231, change: 0 }] },
        { name: 'Passenger Ground Transportation', children: [{ name: 'UBER', value: 151, change: 0 }] },
        { name: 'Specialized Consumer Services', children: [{ name: 'DASH', value: 70, change: 0 }] },
        {
          name: 'Systems Software',
          children: [
            { name: 'MSFT', value: 2940, change: 0 },
            { name: 'PANW', value: 136, change: 0 },
            { name: 'NOW', value: 119, change: 0 },
            { name: 'CRWD', value: 112, change: 0 },
          ],
        },
      ],
    },
    {
      name: 'AI',
      children: [
        {
          name: 'AI Semiconductors',
          children: [
            { name: 'NVDA', value: 4380, change: 0 },
            { name: 'TSM', value: 1755, change: 0 },
            { name: 'AVGO', value: 1530, change: 0 },
            { name: 'ASML', value: 528, change: 0 },
            { name: 'MU', value: 480, change: 0 },
            { name: 'AMD', value: 315, change: 0 },
            { name: 'INTC', value: 229, change: 0 },
            { name: 'QCOM', value: 139, change: 0 },
          ],
        },
        {
          name: 'AI Infrastructure',
          children: [
            { name: 'SPCX', value: 2100, change: 0 },
            { name: 'SMCI', value: 35, change: 0 },
            { name: 'ANET', value: 168, change: 0 },
            { name: 'DELL', value: 100, change: 0 },
            { name: 'VRT', value: 99, change: 0 },
          ],
        },
        {
          name: 'AI Software & Platforms',
          children: [
            { name: 'GOOG', value: 3650, change: 0 },
            { name: 'MSFT', value: 2940, change: 0 },
            { name: 'AMZN', value: 2230, change: 0 },
            { name: 'META', value: 1550, change: 0 },
            { name: 'ORCL', value: 446, change: 0 },
            { name: 'PLTR', value: 361, change: 0 },
            { name: 'IBM', value: 231, change: 0 },
            { name: 'CRM', value: 178, change: 0 },
            { name: 'NOW', value: 119, change: 0 },
            { name: 'ADBE', value: 102, change: 0 },
            { name: 'PATH', value: 6, change: 0 },
            { name: 'SOUN', value: 3, change: 0 },
          ],
        },
        {
          name: 'AI Hardware & Edge',
          children: [
            { name: 'AAPL', value: 3670, change: 0 },
            { name: 'TSLA', value: 1470, change: 0 },
          ],
        },
      ],
    },
    {
      name: 'Defense',
      children: [
        {
          name: 'Aerospace & Defense',
          children: [
            { name: 'SPCX', value: 2100, change: 0 },
            { name: 'RTX', value: 275, change: 0 },
            { name: 'BA', value: 165, change: 0 },
            { name: 'LMT', value: 149, change: 0 },
            { name: 'LHX', value: 42, change: 0 },
            { name: 'HON', value: 149, change: 0 },
            { name: 'NOC', value: 104, change: 0 },
            { name: 'GD', value: 95, change: 0 },
            { name: 'HWM', value: 95, change: 0 },
            { name: 'TDG', value: 69, change: 0 },
            { name: 'AXON', value: 40, change: 0 },
            { name: 'RKLB', value: 39, change: 0 },
            { name: 'KTOS', value: 16, change: 0 },
            { name: 'HII', value: 16, change: 0 },
            { name: 'DRS', value: 12, change: 0 },
            { name: 'AVAV', value: 10, change: 0 },
            { name: 'PL', value: 8, change: 0 },
            { name: 'FLY', value: 4, change: 0 },
            { name: 'LUNR', value: 4, change: 0 },
            { name: 'RCAT', value: 2, change: 0 },
            { name: 'RDW', value: 2, change: 0 },
          ],
        },
        {
          name: 'Defense IT & Analytics',
          children: [
            { name: 'PLTR', value: 361, change: 0 },
            { name: 'IBM', value: 231, change: 0 },
            { name: 'LDOS', value: 22, change: 0 },
          ],
        },
      ],
    },
  ],
};

// Unique tickers tracked by the Finnhub worker (keep in sync with treemap-fetcher.py)
export const TRACKED_TICKERS = [
  'AAPL', 'ADI', 'ADBE', 'AMAT', 'AMD', 'AMZN', 'ANET', 'ASML', 'AVAV', 'AVGO', 'AXON', 'BA', 'CRM', 'CRWD', 'DASH',
  'DELL', 'DRS', 'FLY', 'GD', 'GE', 'GOOG', 'HII', 'HON', 'HWM', 'IBM', 'INTC', 'KLAC', 'KTOS', 'LDOS',
  'LHX', 'LMT', 'LUNR', 'META', 'MSFT', 'MU', 'NOC', 'NOW', 'NVDA', 'ORCL', 'PANW', 'PATH', 'PL', 'PLTR', 'QCOM',
  'RCAT', 'RDW', 'RKLB', 'RTX', 'SMCI', 'SNDK', 'SOUN', 'SPCX', 'STX', 'TDG', 'TSLA', 'TSM', 'TXN', 'UBER', 'VRT',
  'WDC',
];